import React from "react";
import { Search, X } from "lucide-react";

export const matchQ = (q) => (o) => !q || JSON.stringify(o).toLowerCase().includes(q.trim().toLowerCase());

export function SearchBox({ value, onChange, placeholder = "Buscar por código, nombre, ciudad…", testid = "search-input", children }) {
  return (
    <div className="flex flex-wrap items-center gap-2 mb-4">
      <div className="relative flex-1 min-w-[200px]">
        <Search className="absolute left-3 top-2.5 h-4 w-4 text-slate-400" />
        <input value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} data-testid={testid}
          className="w-full rounded-lg border border-slate-300 bg-white pl-9 pr-8 py-2 text-sm outline-none focus:border-[#3B82F6] focus:ring-2 focus:ring-blue-100" />
        {value && <button onClick={() => onChange("")} data-testid={`${testid}-clear`} className="absolute right-2 top-2 text-slate-400 hover:text-slate-600"><X className="h-4 w-4" /></button>}
      </div>
      {children}
    </div>
  );
}

export function FilterSelect({ value, onChange, options, testid }) {
  return (
    <select value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid}
      className="rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-[#0A1F44] outline-none focus:border-[#3B82F6]">
      {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
    </select>
  );
}
